// extracted by mini-css-extract-plugin
export default {"button":"_61xJuLebnHoNvbu6oJ7RT6","infoContainer":"wiNLBwWPEbgBYULg3J8zm","infoIcon":"_69n7aLVngkd8XXkjqXfoN5"};